import { Navigation } from "swiper/modules";
import Slider from "../components/slider";

let contentSlider = null;

function initMobileSlider() {
  if (!contentSlider) {
    contentSlider = new Slider(".js-category-slider", {
      modules: [Navigation],
      spaceBetween: 20,
      slidesPerView: "auto",
      centeredSlides: true,
      loop: false,
      grabCursor: true,
      breakpoints: {
        768: {
          slidesPerView: 3,
          spaceBetween: 24,
          centeredSlides: false,
          slidesPerGroup: 3,
          navigation: {
            nextEl: ".js-category-swiper-button-next",
            prevEl: ".js-category-swiper-button-prev",
          },
        },
      },
    });
  }
}

initMobileSlider();

window.addEventListener("resize", initMobileSlider);
